module.exports = __webpack_public_path__ + "img/1.7d21133c.png";